import { createAccountStore } from "@/stores/account"
import { useTranslation } from "react-i18next"

import BasicButton from "@/components/button/BasicButton"
import Icon from "@/components/icon/Icon"
import { colors } from "@/components/colors"
import { convertGender } from "@/utils/format"
import { getSportLabel } from "@/constants/sportConfig"
import ImageFallback from "@/app/components/ImageFallback"

import "./teamInfo.scss"

export default function TeamInfo({ onClickOpenAPI }: { onClickOpenAPI: () => void }) {
  const { t } = useTranslation()
  const { teamProfileInfo } = createAccountStore()

  return (
    <div className="TeamInfoCont">
      <ImageFallback image={teamProfileInfo?.image} iconType="no-team" size={110} />
      <div className="TeamInfo-text">
        <div className="TeamInfo-title">
          <h1>{teamProfileInfo?.name}</h1>
          <BasicButton type="ghost" size="sm" onClick={onClickOpenAPI}>
            <p>Open API</p>
            <Icon type="arrow-right" color={colors.neutral.grey[600]} size={16} />
          </BasicButton>
        </div>
        <div className="TeamInfo-details">
          <span>
            <p>{t("sport")}</p>
            <p>{getSportLabel(teamProfileInfo?.sportType)}</p>
          </span>
          <span>
            <p>{t("country")}</p>
            <p>{teamProfileInfo?.country}</p>
          </span>
          <span>
            <p>{t("groupAge")}</p>
            <p>{teamProfileInfo?.groupAge}</p>
          </span>
          <span>
            <p>{t("gender")}</p>
            <p>{teamProfileInfo?.gender && convertGender(teamProfileInfo.gender)}</p>
          </span>
          <span>
            <p>{t("category")}</p>
            <p>{teamProfileInfo?.division}</p>
          </span>
        </div>
      </div>
    </div>
  )
}
